module.exports = __webpack_public_path__ + "img/product3p.336f3c96.png";